import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import logo from '../logo.png';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="container section-padding">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 p-4">
          
          {/* 🏢 Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div
                style={{
                  width: '32px',
                  height: '32px',
                  background: 'white',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden', // ensures image fits nicely inside rounded div
                }}
              >
                <img
                  src={logo}
                  alt="Logo"
                  className="brightness-0"
                  style={{
                    width: '24px',
                    height: '24px',
                    objectFit: 'contain',
                  }}
                />
              </div>
              <span className="text-xl font-bold">NS7VISUALS</span>
            </div>

            <p className="text-gray-300 leading-relaxed pr-5">
              We build brands that connect visually, speak strategically, and perform digitally.
            </p>

            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/ns7visuals"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-yellow-400 transition-colors"
              >
                <Facebook size={20} className="cursor-pointer" />
              </a>

              <a
                href="https://x.com/ns7visuals"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-yellow-400 transition-colors"
              >
                <Twitter size={20} className="cursor-pointer" />
              </a>

              <a
                href="https://www.instagram.com/ns7visuals/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-yellow-400 transition-colors"
              >
                <Instagram size={20} className="cursor-pointer" />
              </a>

              <a
                href="https://www.linkedin.com/company/ns7visuals"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-yellow-400 transition-colors"
              >
                <Linkedin size={20} className="cursor-pointer" />
              </a>
            </div>
          </div>

          {/* ⚡ Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-yellow-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-yellow-400 transition-colors">About</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-yellow-400 transition-colors">Services</Link></li>
              <li><Link to="/portfolio" className="text-gray-300 hover:text-yellow-400 transition-colors">Portfolio</Link></li>
              <li><Link to="/team" className="text-gray-300 hover:text-yellow-400 transition-colors">Team</Link></li>
            </ul>
          </div>

          {/* 💼 Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Services</h3>
            <ul className="space-y-2">
              <li><span className="text-gray-300">Brand Identity</span></li>
              <li><span className="text-gray-300">Web Design</span></li>
              <li><span className="text-gray-300">UI/UX Design</span></li>
              <li><span className="text-gray-300">Print Design</span></li>
            </ul>
          </div>

          {/* 📞 Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">Contact Info</h3>
            <div className="space-y-3 text-gray-300">
              
              {/* 📍 Location (opens Google Maps) */}
              <div className="flex items-center space-x-3">
                <MapPin size={18} />
                <a
                  href="https://www.google.com/maps?q=Mumbai,+Maharashtra"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-yellow-400 transition-colors"
                >
                  Mumbai, Maharashtra
                </a>
              </div>

              {/* 📞 Phone (WhatsApp or Dialer) */}
              <div className="flex items-center space-x-3">
                <Phone size={18} />
                <a
                  href="https://wa.me/918698603964"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-green-400 transition-colors"
                >
                  +91 8698603964
                </a>
              </div>

              {/* 📧 Email (mailto) */}
              <div className="flex items-center space-x-3">
                <Mail size={18} />
                <a
                  href="mailto:contact@ns7visuals.com"
                  className="hover:text-blue-400 transition-colors"
                >
                  contact@ns7visuals.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* 📄 Footer Bottom */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 NS7VISUALS. All rights reserved. | Privacy Policy | Terms of Service
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
